import { getToken } from 'firebase/messaging';
import { messaging } from '../firebase';
import { PrivateAxios } from '../environment/AxiosInstance';

export const requestForToken = async (id) => {
    try {
        const currentToken = await getToken(messaging, {
            vapidKey: "BHsHCVYrpHg0yb7_m9pZCfEj-nt3l14FbO6PTBxc2AeLUCh_Hvk2dGBLXf9fIJLgk9zaatgEVWBarmqv8qLwWGw", // From Firebase Cloud Messaging settings
        });

        if (currentToken) {
            PrivateAxios.post("user/update-webToken", { id: id, web_token: currentToken })
                  .then((res) => {
                  }).catch((err) => {
                  })
        } else {
            return { token: currentToken };
        }
    } catch (error) {
        return { token: false };
    }
};